module.exports = __webpack_public_path__ + "img/mp4.fadc2383.png";